import { canonicalize } from '@meteor/canonicalize';
import { createLoader } from '@meteor/data-hooks';
import { useRef, useState } from 'react';
import { withAuth } from '../../user';
import { threadClient } from '../client';

export let runsLoader = createLoader({
  name: 'runs',
  hash: i => canonicalize(i),
  fetch: (i: {
    status?: 'success' | 'error';
    cursor?: string;
    toDate?: Date;
    fromDate?: Date;
    agentId?: string;
    threadId?: string;
    instanceId?: string;
    withSandbox?: boolean;
    organizationId: string;
  }) =>
    withAuth(() =>
      threadClient.run.list({
        ...i,
        limit: 50,
        order: 'desc'
      })
    ),
  mutators: {}
});

export let useRuns = (
  organizationId: string | null | undefined,
  {
    toDate,
    status,
    agentId,
    fromDate,
    threadId,
    instanceId,
    withSandbox
  }: {
    toDate?: Date;
    fromDate?: Date;
    withSandbox?: boolean;
    status?: 'success' | 'error';
    agentId?: string | null | undefined;
    threadId?: string | null | undefined;
    instanceId?: string | null | undefined;
  }
) => {
  let [cursor, setCursor] = useState<string>();
  let runs = runsLoader.use(
    organizationId
      ? {
          cursor,
          status,
          toDate,
          fromDate,
          withSandbox,
          organizationId,
          agentId: agentId || undefined,
          threadId: threadId || undefined,
          instanceId: instanceId || undefined
        }
      : null
  );

  let dataRef = useRef(runs.data);
  dataRef.current = runs.data;

  return {
    ...runs,
    next: () => {
      let c = dataRef.current?.pagination.afterCursor;
      if (c) setCursor(c);
    },
    previous: () => {
      let c = dataRef.current?.pagination.beforeCursor;
      if (c) setCursor(c);
    }
  };
};

export let runLoader = createLoader({
  name: 'run',
  hash: i => i.runId + i.organizationId,
  parents: [runsLoader],
  fetch: (i: { runId: string; organizationId: string }) =>
    withAuth(() => threadClient.run.get(i)),
  mutators: {}
});

export let useRun = (
  organizationId: string | null | undefined,
  runId: string | null | undefined
) => runLoader.use(runId && organizationId ? { runId, organizationId } : null);
